import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Access from './pages/Access';

import CreateGallery from './pages/CreateGallery';
import Gallery from './pages/Gallery';
import GalleryWhiteLabel from './pages/GalleryWhiteLabel';
import CreateSingle from './pages/CreateSingle';
import CreateCollection from './pages/CreateCollection';
import Collection from './pages/Collection';
import ExploreGalleries from './pages/ExploreGalleries';
import ExploreExhibitions from './pages/ExploreExhibitions';
import ExploreCollections from './pages/ExploreCollections';
import ExploreArtists from './pages/ExploreArtists';
import Explore from './pages/Explore';
import Learn from './pages/Learn';
import LearnMore from './pages/LearnMore';
import Profile from './pages/Profile';
import EditProfile from './pages/EditProfile';
import Item from './pages/Item';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import HomeGalleryWL from './pages/HomeGalleryWL';
import Single from './pages/Single';
import Tickets from './pages/Tickets';



function App() {
    return (
      <Router>
        <Routes>
          <Route path="/home" element={<Home />} />
          <Route path="/" element={<Access />} />
          <Route path="/create-single" element={<CreateSingle />} />
          <Route path="/create-gallery" element={<CreateGallery />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/gallerywl" element={<GalleryWhiteLabel />} />
          <Route path="/create-collection" element={<CreateCollection  />} />
          <Route path="/collection" element={<Collection  />} />
          <Route path="/explore" element={<Explore />} />
          <Route path="/galleries" element={<ExploreGalleries  />} />
          <Route path="/collections" element={<ExploreCollections  />} />
          <Route path="/artists" element={<ExploreArtists  />} />
          <Route path="/exhibitions" element={<ExploreExhibitions  />} />
          <Route path="/learn" element={<Learn />} />
          <Route path="/learn-more" element={<LearnMore />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/edit-profile" element={<EditProfile />} />
          <Route path="/item" element={<Item />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/home-gallery" element={<HomeGalleryWL />} />
          <Route path="/single" element={<Single />} />
          <Route path="/tickets" element={<Tickets />} />



        </Routes>
      </Router>
    );
  }
  
  export default App;